import React from 'react'
import cx from 'classnames'
import { scoreBucket } from 'components/modals/TestsReportModal/tabs/helpers'
import { capitalizeFirstLetter } from 'utils/stringFormat'

import styles from './CandidateBellCurve.module.scss'

// SVG paths for the below-average, average, and above-average curve sections.
const RANGE_PATHS = {
  below: 'M0 183 C72 179 123 151 176 87 L176 183 Z',
  average:
    'M176 183 L176 87 C220 34 258 0 293 0 C329 0 367 34 410 87 L410 183 Z',
  above: 'M410 183 L410 87 C462 151 514 179 586 183 Z',
}

const getRange = score => {
  if (score >= 70) return 'above'
  if (score >= 30) return 'average'
  return 'below'
}

const getRangeLabel = (score, language) =>
  capitalizeFirstLetter(scoreBucket(score, language)[1])

export const CandidateBellCurve = ({ score, language }) => {
  const selectedRange = getRange(score)

  return (
    <div className={styles.container}>
      <svg aria-hidden="true" className={styles.curve} viewBox="0 0 586 183">
        {Object.entries(RANGE_PATHS).map(([range, path]) => (
          <path
            key={range}
            className={cx(styles.range, {
              [styles.selected]: selectedRange === range,
            })}
            d={path}
          />
        ))}

        <path className={styles.divider} d="M176 87 V183" />
        <path className={styles.divider} d="M410 87 V183" />
        <path className={styles.baseline} d="M0 183 H586" />
      </svg>

      <div className={styles.labels}>
        <div className={styles.rangeLabel}>{getRangeLabel(0.2, language)}</div>
        <div className={styles.averageIndicator}>
          <div className={cx(styles.bracket, styles.bracketLeft)} />
          <div className={styles.averageLabel}>
            {getRangeLabel(0.5, language)}
          </div>
          <div className={cx(styles.bracket, styles.bracketRight)} />
        </div>
        <div className={styles.rangeLabel}>{getRangeLabel(0.8, language)}</div>
      </div>
    </div>
  )
}
